(function () {
  'use strict';
  if (window.NNStock) return;
  var pending = null;
  var lastAttempt = 0;
  var labels = (window.NN || {}).strings || {};

  function apply(section) {
    if (!section) return;
    var node = section.querySelector('[data-variant-json]');
    var select = section.querySelector('[data-variant-select]');
    if (!node || !select) return;
    var variants;
    try { variants = JSON.parse(node.textContent); } catch (error) { return; }
    var current = variants.find(function (item) { return String(item.id) === select.value; });
    if (!current) return;
    var orderable = current.available && current.state !== 'sold_out';
    var preorder = current.state === 'preorder';
    var stock = section.querySelector('[data-clothing-stock]');
    if (stock) {
      stock.textContent = preorder ? labels.preorder : (!orderable ? labels.soldOut : (current.quantity === null ? labels.available : (labels.stockCount || '__count__').replace('__count__', current.quantity)));
      stock.classList.toggle('is-unavailable', !orderable);
      stock.classList.toggle('is-preorder', preorder);
    }
    var note = section.querySelector('[data-stock-note]');
    if (note) note.textContent = preorder ? (labels.preorderDate || '__date__').replace('__date__', current.incomingDate) : (!orderable ? labels.restockPending : '');
    var request = section.querySelector('[data-preorder-request]');
    if (request) {
      request.hidden = orderable;
      request.href = 'mailto:' + request.dataset.email + '?subject=' + encodeURIComponent(labels.preorderSubject + ' ' + request.dataset.productTitle + ' / ' + current.title);
    }
    var button = section.querySelector('[data-add-button]');
    var form = select.form;
    if (button) {
      button.disabled = !orderable || !!(form && (form.__nnAdding || form.__nnChecking));
      button.textContent = form && form.__nnAdding ? labels.adding : (preorder ? labels.preorder : (orderable ? labels.addToCart : labels.soldOut));
    }
    var price = section.querySelector('[data-variant-price]');
    if (price) price.textContent = current.price;
    var sku = section.querySelector('[data-variant-sku]');
    if (sku) sku.textContent = current.sku ? ' · ' + current.sku : '';
    if (select.options) {
      Array.from(select.options).forEach(function (option) {
        var variant = variants.find(function (item) { return String(item.id) === option.value; });
        if (!variant) return;
        option.textContent = variant.title + (variant.state === 'preorder' ? ' – ' + labels.preorder : (!variant.available || variant.state === 'sold_out' ? ' – ' + labels.soldOut : ''));
      });
    }
    if (form) {
      var marker = form.querySelector('[data-preorder-property]');
      if (preorder) {
        if (!marker) {
          marker = document.createElement('input');
          marker.type = 'hidden';
          marker.name = 'properties[Pre-order]';
          marker.setAttribute('data-preorder-property', '');
          form.appendChild(marker);
        }
        marker.value = (labels.preorderDate || '__date__').replace('__date__', current.incomingDate);
      } else if (marker) marker.remove();
    }
  }

  function merge(scope, html) {
    var fresh = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
    var nextScope = Array.from(fresh.querySelectorAll('[data-stock-section]')).find(function (node) {
      return node.dataset.stockSection === scope.dataset.stockSection;
    });
    if (!nextScope) throw new Error('Stock section missing');
    if (scope.matches('[data-product-section]')) {
      var current = scope.querySelector('[data-variant-json]');
      var next = nextScope.querySelector('[data-variant-json]');
      if (!current || !next) throw new Error('Stock data missing');
      var list = JSON.parse(next.textContent);
      var selected = scope.querySelector('[data-variant-select]');
      if (!selected || !Array.isArray(list) || !list.length || !list.some(function (v) { return String(v.id) === selected.value; })) throw new Error('Selected variant missing');
      current.textContent = next.textContent;
      apply(scope);
    }
    scope.querySelectorAll('[data-stock-fragment]').forEach(function (node) {
      var next = nextScope.querySelector('[data-stock-fragment="' + node.dataset.stockFragment + '"]');
      if (next) { node.hidden = next.hidden; node.textContent = next.textContent; }
    });
    scope.querySelectorAll('[data-nn-clothing-card]').forEach(function (card) {
      var next = nextScope.querySelector('[data-product-id="' + card.dataset.productId + '"]');
      if (!next) return;
      ['data-available', 'data-clothing-sizes'].forEach(function (name) { card.setAttribute(name, next.getAttribute(name)); });
      ['[data-stock-badge]', '.nn-clothing-sizes'].forEach(function (selector) {
        var oldNode = card.querySelector(selector);
        var newNode = next.querySelector(selector);
        if (oldNode && newNode) oldNode.replaceWith(newNode.cloneNode(true));
      });
    });
    scope.querySelectorAll('[data-stock-refresh]').forEach(function (node) { node.textContent = labels.stockUpdated; });
  }

  function refresh() {
    if (pending) return pending;
    if (document.hidden) return Promise.resolve(false);
    var scopes = Array.from(document.querySelectorAll('[data-stock-section]'));
    if (!scopes.length) return Promise.resolve(true);
    lastAttempt = Date.now();
    pending = (async function () {
      var fallback = null;
      function fetchStock(url, format) {
        var controller = new AbortController();
        var timer = setTimeout(function () { controller.abort(); }, 8000);
        return fetch(url.toString(), { credentials: 'same-origin', cache: 'no-store', signal: controller.signal, headers: { Accept: format === 'json' ? 'application/json' : 'text/html' } })
          .then(function (response) {
            if (!response.ok) throw new Error('Stock request failed');
            return format === 'json' ? response.json() : response.text();
          }).finally(function () { clearTimeout(timer); });
      }
      function fullPage() {
        if (!fallback) {
          var pageUrl = new URL(window.location.href);
          pageUrl.searchParams.delete('section_id');
          pageUrl.searchParams.delete('sections');
          pageUrl.searchParams.set('_stock', lastAttempt);
          fallback = fetchStock(pageUrl, 'html').then(function (html) {
            return new DOMParser().parseFromString(html, 'text/html');
          });
        }
        return fallback;
      }
      var success = true;
      for (var offset = 0; offset < scopes.length; offset += 5) {
        var batch = scopes.slice(offset, offset + 5);
        var url = new URL(window.location.href);
        url.searchParams.delete('section_id');
        url.searchParams.set('sections', batch.map(function (scope) { return scope.dataset.stockSection; }).join(','));
        url.searchParams.set('_stock', lastAttempt);
        var result = await fetchStock(url, 'json').catch(function () { return {}; });
        var retry = batch.filter(function (scope) {
          var html = result && result[scope.dataset.stockSection];
          if (typeof html !== 'string') return true;
          try { merge(scope, html); return false; } catch (error) { return true; }
        });
        if (!retry.length) continue;
        var page = await fullPage().catch(function () { return null; });
        retry.forEach(function (scope) {
          try {
            if (!page) throw new Error('Stock fallback unavailable');
            merge(scope, page);
          } catch (error) {
            success = false;
            scope.querySelectorAll('[data-stock-refresh]').forEach(function (node) { node.textContent = labels.stockError; });
          }
        });
      }
      document.dispatchEvent(new CustomEvent('nn:stock-updated'));
      return success;
    })().finally(function () { pending = null; });
    return pending;
  }

  window.NNStock = { apply: apply, refresh: refresh };
  document.querySelectorAll('[data-product-section]').forEach(apply);
  document.addEventListener('change', function (event) {
    if (event.target.matches('[data-variant-select]')) {
      apply(event.target.closest('[data-product-section]'));
      refresh();
    }
  });
  function resume() { if (!document.hidden && Date.now() - lastAttempt > 2000) refresh(); }
  document.addEventListener('visibilitychange', resume);
  window.addEventListener('focus', resume);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('[data-product-section]').forEach(apply); refresh(); });
  setInterval(function () { if (!document.hidden) refresh(); }, 30000);
})();
